// extracted by mini-css-extract-plugin
export default {"catUpDiv":"CategoryData_catUpDiv__U7OED"};